import React from 'react';
import ErrorPage from 'src/components/ErrorPage';
import { Button } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

const Error403View = (props) => {
  const accessDeniedIcon = 'https://nsdstaticasset.blob.core.windows.net/assets/Platform_Status_Images/403.png';
  return (
    <ErrorPage
      title='403: Access denied'
      header="403: You don't have access"
      // message='Please ask an administrator to give you access, then logout and log back in'
      imgSrc={accessDeniedIcon}
      imgAlt='403: Access denied'
      button={(
        <Button
          color='secondary'
          component={RouterLink}
          to='/'
          variant='outlined'
        >
          Back to home
        </Button>
      )}
      {...props}
    />
  );
};

export default Error403View;
